import MultiLinkedBookkeepingList from "components/Picker/Bookkeeping/MultiLinkedBookkeepingList";
import { ModalForMultiPicker } from "components/Picker/ModalForMultiPicker";
import React from "react";
import { LinkedBookkeepingsPanel } from "./LinkedBookkeepingsPanel";

interface Props {
  wordTemplateId: number;
}

export const LinkedBookkeepingsWordTemplatePanel = (props: Props) => {
  const [isNewModalOpen, setIsNewModalOpen] = React.useState(false);
  const [queryKeyIncrement, setQueryKeyIncrement] = React.useState(0);

  const onAddBookkeepings = async (newBookkeepings: server.dto.BookkeepingSmall[]) => {
    await window.CoreApi.WordTemplate.LinkBookkeepings({
      wordTemplateForDetailViewId: props.wordTemplateId,
      bookkeepingIds: newBookkeepings.map(bk => bk.bookkeepingId),
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
    setIsNewModalOpen(false);
  }

  const unlinkBookkeeping = async (bookkeeping: server.dto.BookkeepingSmall) => {
    await window.CoreApi.WordTemplate.UnlinkBookkeepings({
      wordTemplateForDetailViewId: props.wordTemplateId,
      bookkeepingIds: [bookkeeping.bookkeepingId],
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
  }

  return <>
    <LinkedBookkeepingsPanel<server.dto.PaginatedLinkedBookkeepingsToWordTemplateInstruction>
      queryKey={queryKeyIncrement.toString()}
      perPage={8}
      title={RESX.Bookkeeping.VisibleInBookkeepings}
      listFunc={window.CoreApi.WordTemplate.PaginatedLinkedBookkeepings}
      initialInstruction={{
        wordTemplateId: props.wordTemplateId,
        whereInOrNotIn: "in",
        keyword: "",
        page: 1,
        perPage: 8,
      }}
      noSelectionLabel={RESX.Bookkeeping.AssignAtLeastOneBookkeeping}
      onDelete={unlinkBookkeeping}
      onAdd={() => setIsNewModalOpen(true)}
      onRemoveAll={() => window.CoreApi.WordTemplate.UnlinkAllForWordTemplate(props.wordTemplateId)}
      onAddAll={() => window.CoreApi.WordTemplate.LinkAllForWordTemplate(props.wordTemplateId)}
    />

    {isNewModalOpen && <ModalForMultiPicker
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.GeneralLabels.Visible}
      modalSize="small"
      onClose={() => setIsNewModalOpen(false)}
      onSave={onAddBookkeepings}
      initialValue={[]}
      renderModalContent={(editedValue, setEditedValue) => <MultiLinkedBookkeepingList
        initialInstruction={{
          wordTemplateId: props.wordTemplateId,
          whereInOrNotIn: "notIn",
          keyword: "",
          page: 1,
          perPage: 20,
        }}
        listFunc={window.CoreApi.WordTemplate.PaginatedLinkedBookkeepings}
        onChange={setEditedValue}
        value={editedValue}
      />}
    />}
  </>
};